var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29669 2.39419C9.27002 2.23099 9.43193 2.09336 9.58043 2.1661C12.3462 3.52085 13.4886 6.54392 12.9227 8.76687C12.8803 8.93321 13.0337 9.06675 13.1582 8.94857C13.4242 8.69598 13.6141 8.31911 13.6978 7.98288C13.7356 7.83131 13.9159 7.73677 14.0415 7.82956C15.4875 8.89742 16.2915 10.9509 15.9022 13.3548C15.4871 15.9181 13.7458 18 10.3277 18C6.90959 18 3.81212 16.0509 4.0089 12.1913C4.1995 8.45266 9.94961 6.38984 9.29669 2.39419ZM10.3424 10.6199C10.3289 10.4631 10.1531 10.369 10.0239 10.4587C5.94701 13.2882 7.5173 18 10.3277 18C13.2056 18 14.1241 15.0242 12.8927 13.572C11.7368 12.2087 10.4908 12.3411 10.3424 10.6199Z",
    fill: "#E82B27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.f50a2912bb2b91b6e8a0e83ad7fe6f45.svg";
export { ForwardRef as ReactComponent };